import axios from 'axios'

// 农产品批发价格数据源（外部接口 https://pfsc.agri.cn）统一请求实例。
// 该站点有跨域与 Referer/Origin 来源校验，浏览器直连会被拦（GET 直接 403），
// 因此开发环境走 vue.config.js 里的 devServer 代理：/pfsc-api -> https://pfsc.agri.cn。
// 生产环境需由后端网关转发同名 /pfsc-api 前缀，或把 baseURL 换成后端转发地址。
const baseURL = '/pfsc-api'

const service = axios.create({
	baseURL,
	timeout: 300000,
})

// request interceptor
service.interceptors.request.use(
	(config) => {
		config.headers['Content-Type'] = 'application/json; charset=UTF-8'
		return config
	},
	(error) => {
		console.log(error)
		return Promise.reject(error)
	}
)

// response interceptor：外部接口返回体即 { code, message, content }，直接透出
service.interceptors.response.use(
	(response) => {
		return response.data
	},
	(error) => {
		console.log(error)
		return Promise.reject(error)
	}
)

export default service
